export default __webpack_public_path__ + "static/media/delivery.03325051.png";